import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface SmartViewConfig {
  totalCount: number;
  lastUpdatedAt: string;
}

export interface SmartViewsState {
  modifySmartViewDrawer: {
    mode: 'create' | 'edit';
    isOpen: boolean;
  };
  viewSmartViewDetails: {
    isOpen: boolean;
    smartViewId?: string;
  },
  selectedSmartViewId?: string;
  loadedSmartViewConfig?: Record<string, SmartViewConfig>;
}

const initialState: SmartViewsState = {
  modifySmartViewDrawer: {
    mode: 'create',
    isOpen: false,
  },
  viewSmartViewDetails: {
    isOpen: false,
  },
  selectedSmartViewId: undefined,
};

export const smartViewsSlice = createSlice({
  name: 'smartViews',
  initialState,
  reducers: {
    openSmartViewDrawer: (state, action: PayloadAction<SmartViewsState['modifySmartViewDrawer']['mode']>) => {
      state.modifySmartViewDrawer.mode = action.payload;
      state.modifySmartViewDrawer.isOpen = true;
    },
    closeSmartViewDrawer: (state) => {
      state.modifySmartViewDrawer.isOpen = false;
    },
    selectSmartView: (state, action: PayloadAction<string | undefined>) => {
      state.selectedSmartViewId = action.payload;
    },
    setSmartViewConfig: (state, action: PayloadAction<{ smartViewId: string; config: SmartViewConfig }>) => {
      state.loadedSmartViewConfig = {
        ...state.loadedSmartViewConfig,
        [action.payload.smartViewId]: action.payload.config,
      };
    },
    closeSmartViewDetailsDrawer: (state) => {
      state.viewSmartViewDetails = {
        isOpen: false,
      };
    },
    openSmartViewDetailsDrawer: (state, action: PayloadAction<string>) => {
      state.viewSmartViewDetails = {
        isOpen: true,
        smartViewId: action.payload,
      };
    },
  },
});

export const {
  openSmartViewDrawer,
  closeSmartViewDrawer,
  selectSmartView,
  setSmartViewConfig,
  closeSmartViewDetailsDrawer,
  openSmartViewDetailsDrawer,
} = smartViewsSlice.actions;

export default smartViewsSlice.reducer;
